import { render, staticRenderFns } from "./BoardResumen.vue?vue&type=template&id=02455430&scoped=true"
import script from "./BoardResumen.vue?vue&type=script&lang=js"
export * from "./BoardResumen.vue?vue&type=script&lang=js"
import style0 from "./BoardResumen.vue?vue&type=style&index=0&id=02455430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02455430",
  null
  
)

export default component.exports